/**
 * Theme Name: project-sscms v1.504.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - 6af4e3507]
 * Version: 1.504.0-2025-06-30T20-24-55
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
/**
 * File lottie/arrow.js
 * Handles setting scroll arrow animation
 */

const lottieArrows = document.querySelectorAll('.lottie-arrow');

if (lottieArrows.length > 0 && typeof lottie == 'object' && typeof theme !== 'undefined') {
  for (let i = 0; i < lottieArrows.length; i++) {
    if (lottieArrows[i]) {
      lottie.loadAnimation({
        container: lottieArrows[i],
        path: theme.path + '/json/arrow.json',
        renderer: 'svg',
        loop: false,
        autoplay: true,
      });
    }
  }
}
